import { render, staticRenderFns } from "./withdrawalHistory.vue?vue&type=template&id=a8066f32&scoped=true&"
import script from "./withdrawalHistory.vue?vue&type=script&lang=js&"
export * from "./withdrawalHistory.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalHistory.vue?vue&type=style&index=0&id=a8066f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8066f32",
  null
  
)

export default component.exports